<!-- Chip Display Mode -->
<ng-container *ngIf="useChipDisplay">
  <span
    class="tw-px-4 tw-py-1 tw-rounded-full tw-text-sm tw-hidden @md:tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-flex-shrink-0 tw-cursor-pointer"
    [ngClass]="{
      'tw-bg-[#102825] tw-text-[#7FFFD4] tw-border-[#1e3a34]': isFilterActive,
      'tw-bg-gray-800 tw-text-gray-300 tw-border-gray-700': !isFilterActive
    }"
    [matMenuTriggerFor]="chipMenu">
    <ng-container *ngIf="isFilterActive">
      <button
        mat-icon-button
        (click)="clearSelection(); $event.stopPropagation()"
        class="tw-w-5 tw-h-5 tw-p-0 tw-flex tw-items-center tw-justify-center">
        <mat-icon inline class="tw-text-sm">close</mat-icon>
      </button>
      Functions:
      <span>{{ chipText }}</span>
    </ng-container>
    <ng-container *ngIf="!isFilterActive">
      <mat-icon inline class="tw-text-[1.2em]">add</mat-icon>
      Job Functions
    </ng-container>
  </span>
  <mat-menu #chipMenu="matMenu" class="job-function-chip-menu" (closed)="onMenuClosed()">
    <div (click)="$event.stopPropagation()">
      <form [formGroup]="form" class="tw-p-1">
        <ng-container *ngTemplateOutlet="multiSelectActions"></ng-container>

        <mat-selection-list formControlName="selectedFunctions" class="tw-w-full md:tw-columns-2">
          <div class="tw-w-full">
            <mat-list-option
              *ngFor="let item of availableJobFunctions"
              [value]="item"
              color="accent"
              class="tw-text-xs md:tw-text-sm tw-border-0 tw-border-solid tw-border-gray-600 tw-border-b">
              {{ item }}
            </mat-list-option>
          </div>
        </mat-selection-list>
      </form>
    </div>
  </mat-menu>
</ng-container>

<!-- Default Form Field Mode -->
<ng-container *ngIf="!useChipDisplay">
  <form [formGroup]="form">
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="job-function-dropdown tw-w-full">
      <mat-label class="tw-text-gray-800 dark:tw-text-white">
        Job Function{{ multiSelect ? 's' : '' }}
      </mat-label>
      <mat-select
        formControlName="selectedFunctions"
        [multiple]="multiSelect"
        [value]="preSelectedJobFunctions"
        (closed)="onDropdownClosed()"
        panelClass="job-function-dropdown-panel"
        placeholder="All">
        <mat-select-trigger>
          {{ getCollapsedStringValue() }}
        </mat-select-trigger>

        <ng-container *ngTemplateOutlet="multiSelectActions"></ng-container>

        <div class="tw-w-full md:tw-columns-2">
          <mat-option
            *ngFor="let item of availableJobFunctions"
            [value]="item"
            color="accent"
            class="tw-text-xs md:tw-text-sm tw-border-0 tw-border-solid tw-border-gray-600 tw-border-b">
            {{ item }}
          </mat-option>
        </div>
      </mat-select>
    </mat-form-field>
  </form>
</ng-container>

<!-- reusable template for action btns -->
<ng-template #multiSelectActions>
  <div *ngIf="multiSelect" class="tw-flex tw-justify-between tw-mb-2 tw-px-1 xl:tw-px-2">
    <button mat-button color="primary" (click)="selectAll()" [disabled]="areAllSelected()">
      Select All
    </button>
    <button mat-flat-button color="primary" (click)="applyAndClose()" class="tw-hidden md:tw-inline-flex">
      Apply
    </button>
    <button mat-button color="primary" (click)="unselectAll()" [disabled]="areNoneSelected()">
      Unselect All
    </button>
  </div>
</ng-template>
